import React from 'react';
import { Stack, Box } from '@mui/material';
import Config from '../lib/Config';
import '../style/fonts.css';
//import { useNavigate } from 'react-router-dom';
/*
import bg_img from '../assets/images/main_bg.jpg';
import { useNavigate } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import FilledInput from '@mui/material/FilledInput';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import PersonIcon from '@mui/icons-material/Person';
import Button from '@mui/material/Button';
*/



export default () => {

 //   const navigate = useNavigate();

    return (
       <Box sx={{ fontFamily: 'Audiowide', fontSize: '16px', cursor:'pointer' }} onClick={()=>{}} >CONFORCE</Box>
    );

}